/* eslint-disable import/prefer-default-export */
export const REQUEST_INSURED_VALUES = 'calculations/INSURABLE_VALUES';
